export default "__VITE_ASSET__DggmpIc0__"